import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  checkoutErrorCellContainer: {
    flexDirection: 'row',
  },
  dot: {
    backgroundColor: primitive.$bbqBrown,
    borderRadius: 9999,
    height: spacing.$1,
    marginHorizontal: spacing.$2,
    marginVertical: spacing.$2,
    width: spacing.$1,
  },
});

export const CheckoutErrorCellContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.checkoutErrorCellContainer, style] });

export const Dot = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.dot, style] });

export const ErrorText = withTypography({
  textAlign: 'center',
  variant: 'copyOne',
  lineHeight: 20,
  style: { marginBottom: 2 },
});
